var map = {
	"./accommodation-rental-active.svg": 83604,
	"./accommodation-rental.svg": 75721,
	"./archive.svg": 47904,
	"./arrow.svg": 67189,
	"./backward.svg": 19909,
	"./batch-add.svg": 73832,
	"./billing-active.svg": 17966,
	"./billing-approval-active.svg": 40052,
	"./billing-approval.svg": 7753,
	"./billing.svg": 39295,
	"./bin.svg": 44597,
	"./bmp.svg": 13143,
	"./btn-fill-in.svg": 36696,
	"./card-active.svg": 12083,
	"./card.svg": 14704,
	"./ciis-active.svg": 43629,
	"./ciis.svg": 85206,
	"./company-active.svg": 29026,
	"./company.svg": 60475,
	"./cross.svg": 88726,
	"./csv.svg": 86054,
	"./dashboard-active.svg": 89677,
	"./dashboard.svg": 13526,
	"./date-picker-prefix.svg": 42914,
	"./doc.svg": 42116,
	"./docx.svg": 95252,
	"./dot.svg": 25115,
	"./drag.svg": 76724,
	"./dropdown-circle-close.svg": 8001,
	"./dropdown-circle-open.svg": 89731,
	"./dropdown-close.svg": 21802,
	"./dropdown-list-active.svg": 43577,
	"./dropdown-list.svg": 52138,
	"./dropdown-open.svg": 28630,
	"./dustbin.svg": 66005,
	"./edit.svg": 82226,
	"./email.svg": 22210,
	"./employee-active.svg": 28721,
	"./employee-approval-active.svg": 85949,
	"./employee-approval.svg": 73926,
	"./employee-colored.svg": 9295,
	"./employee-review-active.svg": 29654,
	"./employee-review.svg": 76375,
	"./employee.svg": 78258,
	"./expatriate-doc-active.svg": 41595,
	"./expatriate-doc.svg": 23880,
	"./facilities-active.svg": 37920,
	"./facilities.svg": 73261,
	"./filter.svg": 57236,
	"./flag-english.svg": 36195,
	"./flag-mandarin.svg": 46273,
	"./generate-wo.svg": 97578,
	"./gif.svg": 86116,
	"./instruction-tooltip.svg": 2780,
	"./jpeg.svg": 59464,
	"./jpg.svg": 35359,
	"./lock.svg": 89807,
	"./logo.svg": 82471,
	"./minus.svg": 64274,
	"./money.svg": 92398,
	"./nodata.svg": 11059,
	"./notif-ciis.svg": 45317,
	"./notif-work-order.svg": 31809,
	"./notification-bing.svg": 96882,
	"./notification-error.svg": 33142,
	"./notification-info.svg": 6832,
	"./notification-success.svg": 3381,
	"./notification-warning.svg": 45344,
	"./notification.svg": 48419,
	"./office-rental-active.svg": 54248,
	"./office-rental-colored.svg": 66088,
	"./office-rental.svg": 14405,
	"./parameters-setup-active.svg": 75393,
	"./parameters-setup.svg": 62946,
	"./pdf.svg": 71928,
	"./permit-active.svg": 338,
	"./permit.svg": 31915,
	"./plus.svg": 87354,
	"./png.svg": 69039,
	"./printer.svg": 7306,
	"./refresh.svg": 21451,
	"./renew.svg": 32149,
	"./search.svg": 88558,
	"./settings-active.svg": 96480,
	"./settings.svg": 48365,
	"./square-accommodation-rental.svg": 80495,
	"./square-approved.svg": 47833,
	"./square-company.svg": 95793,
	"./square-converted.svg": 40246,
	"./square-draft.svg": 14957,
	"./square-employee.svg": 45756,
	"./square-new.svg": 62086,
	"./square-office-rental.svg": 61223,
	"./square-rejected-ciis.svg": 47575,
	"./square-rejected-work-order.svg": 8127,
	"./square-submitted.svg": 5683,
	"./square.svg": 38563,
	"./telco-services-active.svg": 32979,
	"./telco-services.svg": 47312,
	"./tick.svg": 1517,
	"./tif.svg": 36679,
	"./tiff.svg": 61323,
	"./unlock.svg": 65442,
	"./upload.svg": 88093,
	"./user-active.svg": 3510,
	"./user.svg": 19095,
	"./users.svg": 58022,
	"./utilities-active.svg": 57633,
	"./utilities.svg": 31234,
	"./warning.svg": 10946,
	"./work-order-active.svg": 13433,
	"./work-order.svg": 90666,
	"./workflow-setup-active.svg": 48912,
	"./workflow-setup.svg": 22717,
	"./xls.svg": 64357,
	"./xlsx.svg": 5815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22050;